import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./icon_i_311_volume_muted.svg"; export default path + "#$"